import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs,validationSchema } from '@/entities/Teams/TeamsFormInputs'

const Teams = {
	Plural: 'Teams',
	Single: 'Team',
	Inputs: Inputs,	
	
	ValidationSchema: validationSchema,
	SaveCallBack: (id) =>{ 
		//router.push(`/leagues/edit/${id}`)
	}
};

export default Teams;
